var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dashboard"
  }, [_c('h4', {
    staticClass: "main-header"
  }, [_vm._v(_vm._s(_vm.$t('navigation_dashboard')))]), _vm.companySetupError ? _c('div', {
    staticClass: "text-center pa-8 font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.$t('company_setup_error')) + " " + _vm._s(_vm.$t('contact_support_for_help')) + " ")]) : _c('div', {
    staticClass: "dashboard-ctn"
  }, [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.dashboardDataLoaded,
      expression: "!dashboardDataLoaded"
    }],
    staticClass: "loader",
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }), _c('v-row', {
    staticClass: "ma-3 mb-0"
  }, [_c('search', {
    staticClass: "search",
    attrs: {
      "campaign": _vm.dashboardCampaign
    }
  })], 1), _c('v-row', {
    staticClass: "px-6 pt-2 pb-4",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "search-label mr-2 mono"
  }, [_vm._v(_vm._s(_vm.$t('dashboard_timeframe')) + ":")]), _vm.isAvailable('saas:dashboard:filters:timeframe') ? _c('v-select', {
    staticClass: "timeframe-select description mono flex-grow-0",
    attrs: {
      "solo": "",
      "dense": "",
      "hide-details": "",
      "items": this.timeframes,
      "item-text": "description",
      "item-value": "value"
    },
    model: {
      value: _vm.timeframe,
      callback: function ($$v) {
        _vm.timeframe = $$v;
      },
      expression: "timeframe"
    }
  }) : _vm._e(), _vm.dashboardFilters.length ? _c('div', {
    staticClass: "search-label ml-4 mr-2 mono"
  }, [_vm._v(_vm._s(_vm.$t('filters')))]) : _vm._e(), _vm._l(_vm.dashboardFilters, function (filter, index) {
    return _c('v-chip', {
      key: `active-filters-${index}`,
      staticClass: "ml-2",
      attrs: {
        "close": "",
        "color": "#f1f1f1",
        "text-color": "#0789b2"
      },
      on: {
        "click": function ($event) {
          return _vm.editActiveFilter(filter);
        },
        "click:close": function ($event) {
          return _vm.removeFilter(filter);
        }
      }
    }, [_vm._v(" " + _vm._s(filter.name) + ": " + _vm._s(filter.value) + " ")]);
  })], 2), _vm.dashboardDataLoaded ? _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('summary-card')], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('unique-count-card')], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('product-card')], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('scan-line-card')], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('scan-by-time-card')], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "8"
    }
  }, [_c('scan-heatmap-card')], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('sku-donut-card')], 1)], 1)], 1) : _vm._e()], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }